/**
 * Convert milliseconds to seconds with amount of digits after comma.
 *
 * @param {number} value Value in milliseconds.
 * @param {number} [fractionDigits=2] fractionDigits Number of digits after comma.
 * @returns {string}
 *
 * @example
 * // Converts "10100" to "10.1"
 * toSeconds(10100, 1);
 */
export function toSeconds(value, fractionDigits = 2) {
    return Number(value / 1000).toFixed(fractionDigits);
}
